import React from 'react';

require('admin-lte/plugins/iCheck/icheck.min.js')
class LoginLayout extends React.Component {
  state = {};

  componentDidMount() {
    document.body.className += " login-page";
  }

  render() {
    return (
      <div className="login-box">
        <div className="login-logo">
          <a href="#"><b>Hue</b>Trade</a>
        </div>
        <div className="login-box-body">
          <p className="login-box-msg">Đăng nhập quản trị</p>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default LoginLayout;



// WEBPACK FOOTER //
// ./components/layouts/login/Login.jsx